export default "__VITE_ASSET__Bi4Un93I__"